module.exports = __webpack_public_path__ + "Flag-474.20ef81bc9048e535e54d2fb05e049cb4.svg";